module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.showData.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false,
      "before-close": _vm.closeFn
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "150px"
    }
  }, [_c('div', {
    staticClass: "v-com-form"
  }, [(_vm.showData.isReadOnly) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择代理商:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agent))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseAgent
    }
  }, [_vm._v("选择代理商")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ProjectTypes.length > 0),
      expression: "ProjectTypes.length>0"
    }],
    staticClass: "edit-form",
    attrs: {
      "label": "选择续订项目:"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeProjectType
    },
    model: {
      value: (_vm.form.ProjectType),
      callback: function($$v) {
        _vm.$set(_vm.form, "ProjectType", $$v)
      },
      expression: "form.ProjectType"
    }
  }, _vm._l((_vm.ProjectTypes), function(item) {
    return _c('el-radio-button', {
      attrs: {
        "size": "small",
        "label": item.ProjectType
      }
    }, [_vm._v(_vm._s(item.ProjectTypeName))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "连续续订园所:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.school))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseSchool
    }
  }, [_vm._v("选择幼儿园")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ContinuePackages.length > 0),
      expression: "ContinuePackages.length>0"
    }],
    attrs: {
      "label": "选择续订套餐:"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeValue
    },
    model: {
      value: (_vm.form.PackageId),
      callback: function($$v) {
        _vm.$set(_vm.form, "PackageId", $$v)
      },
      expression: "form.PackageId"
    }
  }, _vm._l((_vm.ContinuePackages), function(item) {
    return _c('el-radio-button', {
      attrs: {
        "size": "small",
        "label": item.PackageId
      }
    }, [_vm._v(_vm._s(item.PackageName))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.PackageId !== 1151 && _vm.form.PackageId !== '' && _vm.form.PackageId !== 5042),
      expression: "form.PackageId!==1151&&form.PackageId!==''&&form.PackageId!==5042"
    }],
    attrs: {
      "label": "支付对象:"
    }
  }, [_c('el-select', {
    staticClass: "formlength",
    attrs: {
      "placeholder": "-请选择-"
    },
    on: {
      "change": _vm.changeObj
    },
    model: {
      value: (_vm.form.PayObject),
      callback: function($$v) {
        _vm.$set(_vm.form, "PayObject", $$v)
      },
      expression: "form.PayObject"
    }
  }, _vm._l((_vm.PayObject), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.Id,
        "label": option.label
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.PackageId !== '' && _vm.form.PackageId !== 1151),
      expression: "form.PackageId!==''&&form.PackageId!==1151"
    }],
    attrs: {
      "label": _vm.titleNum + ':'
    }
  }, [_c('el-input-number', {
    staticClass: "formlength",
    attrs: {
      "step": _vm.step,
      "min": 1
    },
    on: {
      "change": _vm.changeNum
    },
    model: {
      value: (_vm.form.ClassNum),
      callback: function($$v) {
        _vm.$set(_vm.form, "ClassNum", $$v)
      },
      expression: "form.ClassNum"
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(上学期总开班数为：" + _vm._s(_vm.showData.PreSemesterClasNum) + "；其中已续班为：" + _vm._s(this.showData.ContinueClassNum) + "；\n                        "), _c('span', [_vm._v("当前订单续班数：" + _vm._s(_vm.form.ClassNum) + "；")]), _vm._v(" ) ")])], 1), _vm._v(" "), _vm._l((_vm.openClassList), function(item, index) {
    return _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.PackageId == 5042),
        expression: "form.PackageId==5042"
      }],
      attrs: {
        "label": '班级' + (index + 1)
      }
    }, [_c('el-select', {
      staticClass: "formlength",
      attrs: {
        "placeholder": "-请选择-"
      },
      model: {
        value: (item.ClassId),
        callback: function($$v) {
          _vm.$set(item, "ClassId", $$v)
        },
        expression: "item.ClassId"
      }
    }, _vm._l((item.ClassLists), function(option) {
      return _c('el-option', {
        key: option.ClassId,
        attrs: {
          "value": option.ClassId,
          "label": option.ClassName
        }
      })
    })), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == 0),
        expression: "index==0"
      }],
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": _vm.addClass
      }
    }, [_vm._v("创建班级")])], 1)
  }), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.PackageId == 1151),
      expression: "form.PackageId==1151"
    }],
    attrs: {
      "label": "选择班级"
    }
  }, [_c('el-select', {
    staticClass: "formlength",
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.form.ClassId),
      callback: function($$v) {
        _vm.$set(_vm.form, "ClassId", $$v)
      },
      expression: "form.ClassId"
    }
  }, _vm._l((_vm.classList), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.ClassId,
        "label": option.ClassName
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.PackageId !== ''),
      expression: "form.PackageId!==''"
    }],
    attrs: {
      "label": "配置资源包:"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(需配置" + _vm._s(_vm.packagesNum) + "套)")]), _vm._v(" "), _vm._l((this.GoodsListNum), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.packagesOne),
        expression: "packagesOne"
      }],
      staticClass: "list"
    }, [_vm._v("\n                        " + _vm._s('开课班级' + (index + 1) + ':')), _c('br'), _vm._v(" "), _c('el-select', {
      staticClass: "formlength",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "placeholder": "-请选择-"
      },
      model: {
        value: (item.List[0].ProId),
        callback: function($$v) {
          _vm.$set(item.List[0], "ProId", $$v)
        },
        expression: "item.List[0].ProId"
      }
    }, _vm._l((_vm.detailsPackages), function(option) {
      return _c('el-option', {
        attrs: {
          "value": option.ProId,
          "label": option.ProNickName
        }
      })
    })), _vm._v(" "), _c('el-input-number', {
      staticClass: "formlength",
      attrs: {
        "step": _vm.step,
        "min": _vm.minNum,
        "max": _vm.maxNumPackage
      },
      model: {
        value: (item.List[0].ProNum),
        callback: function($$v) {
          _vm.$set(item.List[0], "ProNum", $$v)
        },
        expression: "item.List[0].ProNum"
      }
    })], 1)
  }), _vm._v(" "), (_vm.form.ProjectType == 2) ? _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.Packages,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源包"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                " + _vm._s(scope.row.ProNickName) + "\n                            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "margin-left": "5px"
          },
          attrs: {
            "size": "small",
            "min": 0
          },
          model: {
            value: (scope.row.ProNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ProNum", $$v)
            },
            expression: "scope.row.ProNum"
          }
        })]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((this.GoodsListNum), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.PackageId == 405),
        expression: "form.PackageId==405"
      }],
      staticClass: "list"
    }, [_vm._v("\n                        " + _vm._s('班级' + (index + 1) + '：') + "\n                        "), _c('span', {
      staticStyle: {
        "width": "150px",
        "display": "inline-block",
        "text-align": "right"
      }
    }, [_vm._v("人数：")]), _vm._v(" "), _c('el-input-number', {
      staticClass: "formlength list",
      attrs: {
        "step": _vm.step,
        "min": 25,
        "max": _vm.maxNumPackage
      },
      model: {
        value: (item.Num),
        callback: function($$v) {
          _vm.$set(item, "Num", $$v)
        },
        expression: "item.Num"
      }
    }), _c('br'), _vm._v(" "), _vm._l((item.List), function(sel, index) {
      return _c('el-form-item', {
        attrs: {
          "label": sel.title,
          "label-width": "166px"
        }
      }, [_c('el-select', {
        staticClass: "list2",
        staticStyle: {
          "width": "200px"
        },
        attrs: {
          "placeholder": "请选择"
        },
        model: {
          value: (sel.ProId),
          callback: function($$v) {
            _vm.$set(sel, "ProId", $$v)
          },
          expression: "sel.ProId"
        }
      }, _vm._l((_vm.package3Details[index]), function(option) {
        return _c('el-option', {
          attrs: {
            "value": option.ProId,
            "label": option.ProNickName
          }
        })
      }))], 1)
    })], 2)
  })], 2), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.price !== 0),
      expression: "price!==0"
    }],
    attrs: {
      "label": "资源包价格:"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "margin-right": "50px"
    }
  }, [_vm._v(_vm._s(_vm.price) + "元")]), _vm._v("\n                    邮费：\n                    "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.postage) + "元")])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.price !== 0),
      expression: "price!==0"
    }],
    attrs: {
      "label": "需支付:"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.totalPrice) + "元")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择收货地址:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeList))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly && _vm.ConsigneeList !== ''),
      expression: "!showData.isReadOnly&&ConsigneeList!==''"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.changeAddress
    }
  }, [_vm._v("修改地址")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人及联系方式:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeListName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送方式:",
      "label-width": "150px"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.SendMode == 223),
      expression: "form.SendMode==223"
    }]
  }, [_vm._v("物流")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.SendMode == 221),
      expression: "form.SendMode==221"
    }]
  }, [_vm._v("快递")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送支付方式:",
      "label-width": "150px"
    }
  }, [_vm._v("\n                    寄付(送货)\n                ")])], 2), _vm._v(" "), _vm._l((_vm.payList), function(item, index) {
    return _c('payTypeInfo', {
      ref: 'payInfo' + (index + 1),
      refInFor: true,
      attrs: {
        "myIndex": (index + 1),
        "value": item,
        "isReadOnly": _vm.showData.isReadOnly,
        "hasDelFn": _vm.isDelShow[index]
      },
      on: {
        "delPayfn": _vm.delPayFn
      }
    })
  }), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }]
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addFn
    }
  }, [_vm._v("新增支付方式")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单备注:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "readonly": _vm.showData.isReadOnly
    },
    model: {
      value: (_vm.form.OrderRemark),
      callback: function($$v) {
        _vm.$set(_vm.form, "OrderRemark", $$v)
      },
      expression: "form.OrderRemark"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 2)], 1), _vm._v(" "), _c('addClass', {
    ref: "refAddClass",
    on: {
      "getClassList": _vm.getClassList
    }
  }), _vm._v(" "), _c('chooseDialog', {
    ref: "chooseDialog",
    on: {
      "dialogList": _vm.getDialogList
    }
  }), _vm._v(" "), _c('AddressDialog', {
    ref: "AddressDialog",
    on: {
      "address": _vm.getAddress,
      "getSchoolConsigneeList": _vm.getSchoolConsigneeList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7529606a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SchoolOrder/BookPackage/ContinueOrderDialog/index.vue
// module id = 1525
// module chunks = 1